import { IdCard } from 'lucide-react';

import { isCardPage } from '@/helpers/featureFlags';

import NavItem from './NavItem';

import { useSelf } from '@/data/user';

const CardNavItem = () => {
  const self = useSelf();

  if (self.isLoading && !self.data) {
    return null;
  }

  if (!isCardPage(self.data)) {
    return null;
  }

  return <NavItem icon={<IdCard />} label="Card" pathname="/card" />;
};

export default CardNavItem;
